<template>
  <div class="tab_action tab_bg">
    <div class="backtop">
      <span class="btncenter">背景管理</span>
    </div>
    <div class="tab" style="position: unset; overflow-y: auto">
      <ul>
        <!-- <li @click="Tab = 0" :class="{ check: Tab == 0 }">色彩</li> -->
        <li @click="Tab = 3" :class="{ check: Tab == 3 }">背景</li>
        <li v-if="false" @click="Tab = 1" :class="{ check: Tab == 1 }">挂件</li>
        <!-- <li @click="Tab=2" :class="{'check':Tab==2}">声音</li> -->
      </ul>

      <div class="liebiao" v-if="Tab == 3">
        <div>
          <span @click="checkTab(2)" :class="{ active: sourceTab == 2 }"
            >平台</span
          >
          <span @click="checkTab(1)" :class="{ active: sourceTab == 1 }"
            >个人</span
          >
        </div>
        <div>
          <select v-model="get2dBgimg.materialType" @change="getBgImg()">
            <option
              :label="item.label"
              :value="item.materialType"
              v-for="(item, i) in categroy"
              :key="i + 'shaixuan'"
            ></option>
          </select>
        </div>
      </div>

      <TabPendant
        v-if="Tab == 1"
        :user="user"
        ref="tabPendant"
        :t9render="t9render"
      ></TabPendant>

      <TabAudio v-if="Tab == 2"></TabAudio>

      <div class="content-box" style="height: unset; margin-bottom: 50px">
        <div v-if="Tab == 0 && !showPanelUp">
          <ul class="tab_ul" style="height: calc(100% - 170px)">
            <li
              :style="
                'background-color:transparent;background-image:url(' +
                transparentBack +
                ')'
              "
              @click="changeColor(1)"
            >
              <div class="tab_text"><span>纯色</span></div>
              <div class="tab_div">透明</div>
            </li>

            <li
              v-for="(back, index) in backList"
              :key="index"
              :style="back.gradient"
              @click="changeColor(2, back)"
            >
              <div class="tab_text">
                <span>{{ back.describe }}</span>
              </div>
              <div class="tab_div">{{ back.text }}</div>
            </li>
          </ul>
        </div>
        <div v-if="Tab == 3 && !showPanelUp">
          <!-- <button @click="showPanelUp = true">上传图片</button> -->
          <ul
            class="tab_ul"
            style="height: calc(100% - 170px); padding-bottom: 0"
          >
            <li
              v-if="sourceTab == 1 && Pagination.pageIndex == 1"
              class="tab_column"
              @click="addUp()"
            >
              +
            </li>
            <template v-if="sourceTab == 2" style="display: inline-block">
              <li :style="'height: 110px;'" @click="changeColor(0)">
                <i
                  class="iconfont icon-shiping-xue"
                  style="color: #585858; font-size: 50px; line-height: 110px"
                ></i>
                <div class="tab_houzhui"><span>AR摄像头</span></div>
                <div class="tab_div">视频输入设备</div>
              </li>
              <li
                :style="
                  'background-color:transparent;background-image:url(' +
                  transparentBack +
                  ')'
                "
                @click="changeColor(1)"
              >
                <div class="tab_houzhui"><span>透明</span></div>
                <div class="tab_div">透明</div>
              </li>

              <li
                v-for="(back, index) in backList"
                :key="index"
                :style="back.gradient"
                @click="changeColor(2, back)"
              >
                <div class="tab_houzhui">
                  <span>{{ back.describe }}</span>
                </div>
                <div class="tab_div">{{ back.text }}</div>
              </li>
            </template>

            <li
              v-for="(back, index) in backListImg"
              :key="index + 'i'"
              :style="transfromImg(back)"
              @click="changeColor(3, back)"
            >
              <!-- <div class="right-con" :style="{backgroundImage: 'url(' + (coverImgUrl ? coverImgUrl : baseImg) + ')', backgroundSize:'contain'}">
</div> -->
              <span class="tab_houzhui">{{ dongtai(back) }}</span>
              <div class="tab_div">{{ back.materialName }}</div>
              <div class="tab_edit" v-if="sourceTab == 1">
                <div @click.stop="editSource(back)"><span>编辑</span></div>
                <div @click.stop="delSource(back.materialId)">
                  <span>删除</span>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div v-show="Tab == 2"></div>

        <div
          v-show="showPanelUp"
          class="add-box addform_box"
          style="bottom: -200px"
        >
          <div class="add-content">
            <div class="setup_title"><i></i>素材上传</div>
            <div class="setup_cancel" @click="showPanelUp = false">返回</div>
            <div class="setup_content">
              <div class="setup_box">
                <div class="setup_lable">素材名称：</div>
                <div class="setup_block">
                  <input
                    type="text"
                    v-model="addForm.materialName"
                    value=""
                    placeholder="请输入素材名称"
                  />
                </div>
              </div>
              <div class="setup_box">
                <div class="setup_lable">素材类型：</div>
                <div class="setup_block">
                  <select v-model="addForm.materialType">
                    <option
                      :label="item.label"
                      :value="item.materialType"
                      v-for="(item, i) in categroy"
                      :key="i"
                    ></option>
                  </select>
                </div>
              </div>
              <div class="setup_box fengmian">
                <div class="setup_lable">素材图片：</div>
                <div class="setup_block" style="position: relative">
                  <div
                    class="uploader"
                    v-if="
                      addForm.materialPath == null ||
                      addForm.materialPath.length <= 0
                    "
                  >
                    +
                  </div>
                  <div
                    v-if="
                      addForm.materialPath != null &&
                      addForm.materialPath.length > 0
                    "
                    class="uploader_img"
                  >
                    <img
                      v-if="isImg(addForm.materialPath)"
                      :src="addForm.materialPath"
                      alt=""
                    />
                    <img
                      v-else-if="addForm.materialJson"
                      :src="addForm.materialJson.materialCover"
                      alt=""
                    />
                    <img v-else :src="defaultImg" alt="" />
                  </div>
                  <div class="defaultupload" @click="opUpFile()">
                    <fileUpload
                      ref="up"
                      v-show="false"
                      id="bgcupload"
                      accept="*"
                      typefolder="stageBgc"
                      parentfolder="material"
                      @progress="uploadProgress"
                      @checkfile="checkfile"
                      @error="uploadError"
                      @success="uploadSuccess"
                    ></fileUpload>
                  </div>
                </div>
              </div>
              <div class="setup_box">
                注意：背景支持图片(jpg、png)与视频(mp4、mov、ogg)
              </div>
              <div v-if="uppro > 0 && uppro < 100">上传中 {{ uppro }}%</div>
            </div>
          </div>

          <div class="savebtn">
            <span @click="saveMaterial" class="confirmbtn">保存素材</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 分页组件 -->
    <pagination
      v-if="backListImg.length > 0 && Tab == 3 && !showPanelUp"
      class="pull-right-dis"
      :paginationOpt="Pagination"
      @switchPage="employeePagesFn"
      style="
        bottom: 30px;
        padding: 0;
        position: absolute;
        right: 0;
        box-shadow: none;
      "
    />
  </div>
</template>
<script>
// import { PixiCommon } from '@/components/other/PixiCommon.js'
import pagination from '@/components/pagination/index.vue'

import fileUpload from '@/components/ali_oss/alioss.vue'
import { repUrl, getVideo, beforeAvatarUpload } from '@/components/util/util_fun.js'
import { t9oss } from '@/components/util/util.js'
import TabPendant from './TabPendant.vue'
import TabAudio from '@/views/setup/TabAudio'

export default {
  components: {
    TabPendant,
    TabAudio,
    fileUpload,
    pagination
  },
  name: 'Background',
  props: ['user', "t9render"],
  data () {
    return {
      defaultImg: require('@/assets/images/defalut.png'),
      uppro: 0,// 文件上传进度
      upproCover: 0,// 封面上传进度
      Pagination: {
        //分页
        pageIndex: 1,
        pageSize: 20,
        totalCount: 1,
        pageCount: 0
      },
      sourceTab: 2,//平台||个人场景
      // backListImgF: [],// 公共背景图片数组
      backListImg: [],// 背景图片数组
      addForm: {
        "materialName": '',
        "materialPath": '',
        "materialType": '2',// 2-1=2D 2-2=3D 2-3=vr场景
        "materialSource": 1,//1.个人上传 2.平台素材
        "materialSize": 0,
        "materialJson": '',
      },
      get2dBgimg: {
        "searchText": "",
        "pageIndex": 0,
        "pageSize": 24,
        "sort": 1,//	排序 1.正序 2.倒序
        "materialType": '2',//2-1=2D 2-2=3D 2-3=vr场景
        "materialSource": 2,//素材来源 0.默认不筛选 1.个人上传 2.平台素材	
      },
      categroy: [{
        "label": "全部分类",
        "materialType": "2",
        "children": []
      }],
      showPanelUp: false,//上传背景图片
      Tab: 3,
      showPanel: false,
      color: "#FFE5D9",//背景色
      transparentBack: require('@/assets/images/background.png'),
      backList: [
        { id: "0", type: "color", x: 1, y: 1, data: [{ 'per': 0, 'color': 'limegreen' }, { 'per': 1, 'color': 'limegreen' }], gradient: "background-color:limegreen", describe: '纯色', text: '绿幕' },
        { id: "1", type: "color", x: 0.19, y: 0, data: [{ 'per': 0, 'color': '#f78ca0' }, { 'per': 0.19, 'color': '#f9748f' }, { 'per': 0.6, 'color': '#fd868c' }, { 'per': 1, 'color': '#fe9a8b' }], describe: '渐变色', text: '强烈的幸福来袭', gradient: "background-image: linear-gradient(to right, #f78ca0 0%, #f9748f 19%, #fd868c 60%, #fe9a8b 100%);" },
        { id: "8", type: "color", x: 1, y: 1, data: [{ 'per': 0, 'color': '#D4FFEC' }, { 'per': 0.48, 'color': '#57F2CC' }, { 'per': 1, 'color': '#4596FB' }], describe: '渐变色', text: '最亮的天空', gradient: "background-image: linear-gradient(-225deg, #D4FFEC 0%, #57F2CC 48%, #4596FB 100%);" },

      ],
    }
  },
  created () {
    // console.log('TabBg页面激活',this.user);
    this.get('/vup/static/config/material.json').then((res) => {

      var guajian = res.data[1].children
      for (let a = 0; a < guajian.length; a++) {
        this.categroy.push(guajian[a])
      }
    })
  },
  destroyed () {
    // console.log('bgImg销毁');;
  },
  mounted () {
    this.getBgImg()
  },
  methods: {
    // 判断是否为图片
    isImg (url) {
      return /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(url)
    },

    getBgImg (cb) { //获取背景图片列表
      this.loading = true

      if (this.get2dBgimg.pageIndex == 0) { // 如果是第一页，则需要减一,因为上传按钮占一个<li/>
        this.get2dBgimg.pageSize = this.get2dBgimg.pageSize - 1
      }
      if (this.get2dBgimg.materialSource == 2) {
        this.get2dBgimg.pageSize = 19   // 如果是平台素材，则每页显示19个 ,一页24条减去,摄像头和四张图片
      }

      this.post("/material/findMaterialList", this.get2dBgimg).then((res) => {
        // console.log('获取背景', res)
        if (res.status == "200") {
          this.get2dBgimg.pageSize = 24 // 恢复正常请求一页页数
          this.backListImg = res.data[0]
          this.Pagination.totalCount = res.data[1]
          this.Pagination.pageCount = Math.ceil(this.Pagination.totalCount / this.Pagination.pageSize)


          this.loading = false
        }
      }).catch(() => {
        this.loading = false
      })
      !!cb && cb()//分页用到了
    },

    opUpFile () { // 上传背景图片
      this.$refs.up.$el.click()
      // .click()
    },
    // 添加素材
    checkSource (source) {
      this.$refs.PanelScene.addSource(source)
      this.Tab = 0
      this.showPanel = true
    },
    closeSource () {

    },
    //修改背景色
    changeColor (type, color) {
      this.color = color
      if (type == 0) {
        var color = { type: "camera" }
        // t9render.runfunction("pixicomm.GradientBgColor",[color]);
        this.$emit("selector", color)
      }
      else if (type == 1) {
        var color = { type: "transparent" }
        // t9render.runfunction("pixicomm.removeAppStageObjectByName",['GradientBg']);
        // t9render.runfunction("pixicomm.removeAppStageObjectByName",['BgImg']);
        // t9render.runfunction("pixicomm.GradientBgColor",[color]);
        this.$emit("selector", color)
      } else if (type == 2) {
        // t9render.runfunction("pixicomm.GradientBgColor",[color]);
        this.$emit("selector", color)
      } else {
        // t9render.runfunction("pixicomm.GradientBgImg",[color]);
        this.$emit("selector", color)
      }


    },
    transfromImg (item) {
      if (this.isImg(item.materialPath)) {
        return {
          backgroundImage: `url('${item.materialPath}?x-oss-process=style/fmslt')`,
          backgroundSize: 'cover',
        }
      } else if (item.materialJson) {
        if (typeof item.materialJson == 'string') {
          item.materialJson = JSON.parse(item.materialJson)
        }
        return {
          backgroundImage: `url('${item.materialJson.materialCover}?x-oss-process=style/fmslt')`,
          backgroundSize: 'cover',
        }
      }

    },
    //清除颜色
    clearColor () {
      this.color = ""
    },
    // 分页
    employeePagesFn (pageIndex, cb) { //pageIndex --- 分页组件返回的页码，    cb ---- 主要目的是为分页加锁，固定参数
      let self = this

      self.Pagination.pageIndex = pageIndex
      self.get2dBgimg.pageIndex = pageIndex - 1

      self.getBgImg(cb)
    },
    /***************************场景管理****************************/
    checkTab (type) {
      // console.log('this.backList清空', this.backList)
      this.showPanelUp = false
      this.get2dBgimg.pageIndex = 0
      this.Pagination.pageIndex = 1
      this.sourceTab = type
      this.get2dBgimg.materialSource = type

      this.getBgImg()
    },
    // 编辑素材
    editSource (source) {
      console.log('点击编辑的回调', source)
      if (typeof source.materialJson == 'string') {
        source.materialJson = JSON.parse(source.materialJson)
      }
      this.addForm = source
      this.showPanelUp = true
    },
    // 删除素材
    delSource (code) {
      // console.log('点击删除的回调', code)
      this.$confirm({
        title: "操作提示",
        type: "warning",
        message: '此操作将永久删除该素材, 是否继续?'
      }).then(() => {

        this.post("/material/deleteMaterial", { code: code }).then((res) => {

          if (res.status == "200") {
            this.backListImg.find((t, index) => {

              if (t.materialId == code) {

                this.backListImg.splice(index, 1)
              }
            })
            this.$message.success("删除成功")

          } else {
            this.$message.error("删除失败")
          }
        })
          .catch((fail) => {

          })

      })
    },
    addUp () {
      this.showPanelUp = true
      this.addForm = {
        "materialName": '',
        "materialPath": '',
        "materialType": '2',// 2-1=2D 2-2=3D 2-3=vr场景
        "materialSource": 1,//1.个人上传 2.平台素材
        "materialSize": 0,
        "materialJson": '', // 放置 封面图片
      },
        console.log('上传show')
    },
    saveMaterial () { //保存素材
      // console.log('保存素材', this.addForm)

      if (this.addForm.materialPath == '') return this.$message.error("文件不能为空")
      if (this.uppro != 100 || this.upproCover != 100) {
        console.log('上传进度', this.uppro, this.upproCover)
        this.$message.warning("请等待文件上传完成")
      }
      if (typeof this.addForm.materialJson != 'string') {
        this.addForm.materialJson = JSON.stringify(this.addForm.materialJson)
      }
      if (this.addForm.materialId) {
        console.log('进入编辑')
        this.post("/material/editMaterial", this.addForm).then((res) => {
          try {
            if (res.status == "200") {
              this.$message.success('修改成功')

            } else if (res.status == "21") {

              this.$message.error(res.message)
            } else {

              this.$message.error('修改失败')
            }
            this.showPanelUp = false
            this.getBgImg()
          } catch (error) {
            console.log('捕获错误')
            console.dir(error)

          }

        })
      } else {
        this.post("/material/saveMaterial", this.addForm).then((res) => {
          console.log('保存素材回调', res)
          if (res.status == 200) {

            // this.backListImg.push(res.data)
            this.getBgImg()
            this.$message.success("添加成功")
            // console.log(this.backListImg)
            this.showPanelUp = false
          }
        })
      }

    },
    // ---------------上传回调-------------------------------------------
    //上传成功！
    async uploadSuccess (json) {
      console.log('素材上传成功的回调', json)
      if (json.fileDir.length <= 0) {
        this.$message.error("上传文件不可用!")
      } else {


        this.addForm.materialPath = t9oss + '/' + repUrl(json.fileUrl)
        this.addForm.materialSize = json.size
        if (this.addForm.materialName == '') { //如果先上传文件，则读取文件的本地名称
          this.addForm.materialName = json.fileName.split('.')[0]
        }
        // 判断是否为对象,如果是字符串,则转换为对象

        if (typeof this.addForm.materialJson == 'string' && this.addForm.materialJson != '') {
          this.addForm.materialJson = JSON.parse(this.addForm.materialJson)
        } else {
          this.addForm.materialJson = {}
        }
        if (json.fileType == 'mp4' || json.fileType == 'mov') {
          try {
            const url = await getVideo(this.addForm, 'stageBgc/material/')
            this.$set(this.addForm.materialJson, 'materialCover', url)
            this.$message.success("上传成功")
          } catch (error) {
            this.addForm.materialJson.materialCover = ''
            this.$message.error("上传文件封面获取失败")
          }
        } else if (json.fileType == 'png' || json.fileType == 'jpg' || json.fileType == 'jpeg') {
          this.addForm.materialJson.materialCover = this.addForm.materialPath
          this.$message.success("上传成功")
        } else {
          this.$message.error("上传文件不可用!")
        }
        console.log('上传成功的this.addForm', this.addForm)


      }
      // console.log('上传成功的表单', this.addForm)
    },


    //上传失败
    uploadError (err) {
      //   this.uploadloading = false
      this.$message.error("上传失败！")
      console.error(err)
    },

    //文件选择成功
    async checkfile (file) {
      //   this.uploadloading = true
      console.log('file', file)

    },
    //进度条
    uploadProgress (progress) {
      console.log('进度', progress)
      this.uppro = parseInt(progress * 100)
    },
    dongtai (back) {
      let name = back.materialPath.toLowerCase().substring(back.materialPath.lastIndexOf('.') + 1)
      if (name == "mov" || name == "ogg" || name == "mp4") {
        return "动态"
      }
      else {
        return ""
      }

    }
  }
}
</script>
<style lang="scss" scoped>
.tab_action .setup_action li {
  background: transparent;
  background-size: cover;
}
.tab_houzhui {
  background-color: #f95f8e;
  color: #fff;
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 0 20px 0 20px;
  padding: 0 12px;
  font-size: 12px;
  line-height: 20px;
}
.setup_cancel {
  width: 60px;
  background-color: #eee;
  border-radius: 12px;
  /* margin: 0 auto; */
  text-align: center;
  cursor: pointer;
}
.liebiao {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  select {
    height: 29px;
    padding: 0 5px;
    color: #666;
    border: 1px solid #dbdbdb;
  }
}
.liebiao span {
  display: inline-block;
  padding: 5px 10px;
  margin: 0 5px;
  background-color: #f7f8fa;
  border-radius: 2px;
  color: #666;
  cursor: pointer;
}
.liebiao .active {
  background-color: #f4acb7;
  color: #fff;
}
.tab_edit {
  border-radius: 0 0 20px 20px;
  height: 30px;
}
.content-box {
}
.tab_action .tab_ul li {
  margin-bottom: 50px;
}
.content-box > div {
  // padding-bottom: 100px;
}
</style>
